import Vue from 'vue'
import Router from 'vue-router'
import Auth from '@/views/Auth.vue'
import Prolongation from '@/views/Prolongation.vue'
// import Home from '@/views/Home.vue'
// import About from '@/views/About.vue'
// import News from '@/views/News.vue'
// import Services from '@/views/Services.vue'
// import Guide from '@/views/Guide.vue'
import cabinet from '@/views/cabinet/cabinet.vue'
import myLombard from '@/views/cabinet/myLombard.vue'
import settings from '@/views/cabinet/settings.vue'
import bonuses from '@/views/cabinet/bonuses.vue'
import referral from '@/views/cabinet/referral.vue'
import AuthFunction from '@/functions/Auth'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    // {
    //   path: '/',
    //   name: 'Home',
    //   component: Home
    // },
    // {
    //   path: '/about',
    //   name: 'About',
    //   component: About
    // },
    // {
    //   path: '/news/:id',
    //   name: 'News',
    //   component: News
    // },
    // {
    //   path: '/services',
    //   name: 'Services',
    //   component: Services
    // },
    // {
    //   path: '/guide',
    //   name: 'Guide',
    //   component: Guide
    // },
    {
      path: '/prolongation',
      name: 'Prolongation',
      component: Prolongation
    },
    {
      path: '/',
      name: 'Auth',
      component: Auth
    },
    {
      path: '/cabinet',
      component: cabinet,
      redirect: '/cabinet/my-lombard',
      children: [
        {
          path: 'my-lombard',
          component: AuthFunction().isLoggedIn() ? myLombard : Auth,
          beforeEnter: (to, from, next) => {
            let redirect = AuthFunction().verifiedUser()
            if (redirect) {
              next(redirect)
            } else {
              next()
            }
          }
        },
        {
          path: 'settings',
          component: AuthFunction().isLoggedIn() ? settings : Auth,
          beforeEnter: (to, from, next) => {
            let redirect = AuthFunction().verifiedUser()
            if (redirect) {
              next(redirect)
            } else {
              next()
            }
          }
        },
        {
          path: 'bonuses',
          component: AuthFunction().isLoggedIn() ? bonuses : Auth,
          beforeEnter: (to, from, next) => {
            let redirect = AuthFunction().verifiedUser()
            if (redirect) {
              next(redirect)
            } else {
              next()
            }
          }
        },
        {
          path: 'referral',
          component: AuthFunction().isLoggedIn() ? referral : Auth,
          beforeEnter: (to, from, next) => {
            let redirect = AuthFunction().verifiedUser()
            if (redirect) {
              next(redirect)
            } else {
              next()
            }
          }
        }
      ]
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    return new Promise(resolve => {
      setTimeout(() => {
        if (savedPosition) resolve(savedPosition)
        else resolve({ x: 0, y: 0 })
      }, 200)
    })
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js